import { __decorate, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import template from './product-orders.component.html';
var ProductOrdersComponent = (function () {
    function ProductOrdersComponent() {
        this.showOrders = false;
    }
    ProductOrdersComponent.prototype.overlayClicked = function () {
        this.showOrders = false;
    };
    ProductOrdersComponent.prototype.toggleOrders = function () {
        this.showOrders = !this.showOrders;
    };
    ProductOrdersComponent.prototype.orderChanged = function (order) {
        this.showOrders = false;
        if (this.onOrderChange) {
            this.onOrderChange({ order: order });
        }
    };
    ProductOrdersComponent.$inect = [];
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], ProductOrdersComponent.prototype, "onOrderChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ProductOrdersComponent.prototype, "orders", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ProductOrdersComponent.prototype, "selectedOrder", void 0);
    ProductOrdersComponent = __decorate([
        Component({
            selector: 'productOrders',
            template: template,
        })
    ], ProductOrdersComponent);
    return ProductOrdersComponent;
}());
export { ProductOrdersComponent };
